<h2 mat-dialog-title class="enforcement-title">
  <span class="enforcement-title-text">Enforcement</span>
  <span class="enforcement-task-title">{{ task.title }}</span>
</h2>

<mat-dialog-content class="enforcement-dialog">
  <p class="enforcement-hint">
    Which pupils' phones were actually blocked during this restriction. The list opens on the
    pupils to chase.
  </p>

  <div class="enforcement-loading" *ngIf="loading && !enforcement">
    <mat-spinner diameter="28"></mat-spinner>
    <span>Checking devices…</span>
  </div>

  <p class="enforcement-empty" *ngIf="unavailable && !loading">
    The devices could not be checked for this restriction. Try again in a moment.
  </p>

  <ng-container *ngIf="enforcement as result">
    <ng-container *ngIf="coverage as cov; else coverageNotMeasured">
      <div class="coverage-block">
        <div class="coverage-head">
          <span class="coverage-headline">{{ coverageHeadline(cov) }}</span>
          <span class="coverage-value" [ngClass]="coverageTone(cov)">{{ coveragePercentageLabel(cov) }}%</span>
        </div>
        <span class="coverage-meter">
          <span class="coverage-meter-fill" [ngClass]="coverageTone(cov)" [style.width.%]="coveragePercentage(cov)"></span>
        </span>
        <div class="coverage-reasons">
          <button
            type="button"
            class="coverage-reason"
            *ngFor="let entry of coverageReasons(cov); trackBy: trackByReason"
            [class.is-active]="isReasonActive(entry.reason)"
            [attr.aria-pressed]="isReasonActive(entry.reason)"
            (click)="toggleReason(entry.reason)">
            {{ entry.count }} {{ entry.label }}
          </button>
        </div>
        <p class="coverage-note" *ngIf="coverageDropped(cov) as dropped">
          {{ dropped }} could no longer be restricted by the time it ended.
        </p>
      </div>
    </ng-container>
    <ng-template #coverageNotMeasured>
      <p class="coverage-empty">Device coverage was not measured for this restriction.</p>
    </ng-template>

    <div class="enforcement-counts">
      <button
        type="button"
        class="enforcement-count count-shielded"
        [class.is-active]="isBucketActive('SHIELDED')"
        [attr.aria-pressed]="isBucketActive('SHIELDED')"
        [matTooltip]="bucketHints.SHIELDED"
        (click)="toggleBucket('SHIELDED')">
        {{ result.confirmedShielded }} confirmed shielded
      </button>
      <button
        type="button"
        class="enforcement-count count-unconfirmed"
        [class.is-active]="isBucketActive('NOT_CONFIRMED')"
        [attr.aria-pressed]="isBucketActive('NOT_CONFIRMED')"
        [matTooltip]="bucketHints.NOT_CONFIRMED"
        (click)="toggleBucket('NOT_CONFIRMED')">
        {{ result.notConfirmed }} not confirmed
      </button>
      <button
        type="button"
        class="enforcement-count count-unreachable"
        [class.is-active]="isBucketActive('NO_DEVICE')"
        [attr.aria-pressed]="isBucketActive('NO_DEVICE')"
        [matTooltip]="bucketHints.NO_DEVICE"
        (click)="toggleBucket('NO_DEVICE')">
        {{ result.notReachable }} no device
      </button>
    </div>

    <div class="pupil-list-head">
      <span class="pupil-list-heading">{{ listHeading }}</span>
      <button type="button" class="pupil-list-toggle" *ngIf="isFiltered" (click)="clearFilters()">
        Back to the pupils to chase
      </button>
      <button type="button" class="pupil-list-toggle" *ngIf="!isFiltered && confirmedCount > 0" (click)="toggleConfirmed()">
        {{ showConfirmed ? 'Hide the shielded pupils' : 'Show all ' + allPupils.length + ' pupils' }}
      </button>
    </div>

    <input
      type="search"
      class="pupil-search"
      placeholder="Search by name"
      aria-label="Search pupils by name"
      *ngIf="allPupils.length > 10"
      [value]="search"
      (input)="onSearch($any($event.target).value)" />

    <p class="enforcement-empty" *ngIf="pupils.length === 0">{{ emptyListMessage }}</p>
    <div class="enforcement-pupils">
      <div
        class="enforcement-pupil"
        *ngFor="let pupil of pupils; trackBy: trackByPupil"
        [ngClass]="pupilClass(pupil)">
        <span class="pupil-name">{{ pupil.childName || pupil.childAccountId }}</span>
        <span class="pupil-state">{{ pupilLabel(pupil) }}</span>
        <span class="pupil-reason" *ngIf="pupilReason(pupil) as reason">{{ reason }}</span>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" color="primary" [disabled]="loading" (click)="load()">
    {{ loading ? 'Checking…' : 'Refresh' }}
  </button>
  <button mat-flat-button color="primary" type="button" (click)="close()">Close</button>
</mat-dialog-actions>
